module.exports = __webpack_public_path__ + "static/Submarkets_2021_Release_5-68ac6c7f70e0a57d6b66f4531daaac9c.png";